import { __decorate } from "tslib";
// NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
//import LiquorTree from 'liquor-tree';
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ServiceEditModel } from "@/store/models/service/UpdateService";
import ServiceModule from "@/store/modules/service.module";
import { toaster } from "../../../utilities/toaster";
import Switches from "vue-switches";
let ServiceUpdate = /** @class */ (() => {
    let ServiceUpdate = class ServiceUpdate extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Services";
            this.ctaButtons = [
                {
                    routeName: "Products",
                },
            ];
            this.items = [
                {
                    text: "Services",
                },
                {
                    text: "Update Service",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedService = new ServiceEditModel();
        }
        // LIFECYCLE
        created() {
            var serviceId = Guid.parse(this.$route.params.id);
            ServiceModule.GetServiceById(serviceId).then((response) => {
                this.pageIsLoading = false;
                this.selectedService = new ServiceEditModel();
                this.selectedService = {
                    id: response.editService.id,
                    name: response.editService.name,
                    latestVersion: response.editService.latestVersion,
                    description: response.editService.description,
                    license: response.editService.license,
                    price: response.editService.price,
                    url: response.editService.url,
                    status: response.editService.status,
                    userLimits: response.editService.userLimits,
                };
            });
        }
        saveService() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    ServiceModule.EditServiceById(this.selectedService).then((response) => {
                        toaster.ShowSuccess("Service was updated successfully. ");
                    });
                    ServiceModule.GetServices().then((response) => { });
                    this.$router.push({ name: "Services" });
                }
            });
        }
        cancelService() {
            this.$router.push({ name: "Services" });
            this.selectedService = new ServiceEditModel();
            this.selectedService = Object.assign({}, this.selectedService);
            this.selectedService = {
                id: this.selectedService.id,
                name: this.selectedService.name,
                latestVersion: this.selectedService.latestVersion,
                description: this.selectedService.description,
                license: this.selectedService.license,
                price: this.selectedService.price,
                url: this.selectedService.url,
                status: this.selectedService.status,
                userLimits: this.selectedService.userLimits,
            };
        }
    };
    ServiceUpdate = __decorate([
        Component({
            name: "ServiceUpdate",
            components: {
                Layout,
                PageHeader,
                Switches,
            },
        })
    ], ServiceUpdate);
    return ServiceUpdate;
})();
export default ServiceUpdate;
